import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';
import { useOrg } from '../pages/orgs/org-context';
import menu from '../menu/controlPlaneMenuConfig';
import './ControlPlaneSidebar.css';

// Same visibility convention as the legacy menu. This grants no access.
function visible(item, user) {
  return !item.roles?.length || user?.globals?.includes('superadmin') ||
    item.roles.some(role => user?.roles?.includes(role));
}

export default function ControlPlaneSidebar({ isOpen, closeSidebar }) {
  const { user } = useAuth();
  const { activeOrgId } = useOrg();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState({});
  if (!user) return null;
  const active = path => pathname === path || pathname.startsWith(`${path}/`);
  const link = (item, level) => item.requiresOrg && !activeOrgId ?
    <span className={`control-plane-nav-item control-plane-nav-${level} control-plane-nav-empty`}
      aria-disabled="true" title="Select an organization in the header">
      <span className="control-plane-nav-label">{item.label}</span>
    </span> : <Link to={item.path}
    className={`control-plane-nav-item control-plane-nav-${level}${active(item.path) ? ' is-active' : ''}`}
    aria-current={active(item.path) ? 'page' : undefined}
    onClick={() => { if (window.innerWidth <= 768) closeSidebar?.(); }}>
    <span className="control-plane-nav-label">{item.label}</span>
  </Link>;

  return <div className={`sidebar control-plane-sidebar ${isOpen ? 'open' : 'closed'}`}>
    <nav aria-label="EveryID Ops">
      <ul className="control-plane-nav-list" aria-label="Ops areas">
        {menu.map(group => {
          if (group.path) return visible(group, user) ? <li key={group.label}>{link(group, 'top')}</li> : null;
          const children = group.children.filter(item => visible(item, user));
          const expanded = !collapsed[group.label];
          const id = `ops-menu-${group.label.toLowerCase()}`;
          return <li key={group.label}>
            <button type="button"
              className={`control-plane-nav-item control-plane-nav-top${children.some(item => active(item.path)) ? ' is-active' : ''}`}
              aria-expanded={expanded} aria-controls={id}
              onClick={() => setCollapsed(current => ({ ...current, [group.label]: expanded }))}>
              <span className="control-plane-nav-label">{group.label}</span>
              <span className="control-plane-nav-chevron" aria-hidden="true">{expanded ? '▾' : '▸'}</span>
            </button>
            <ul id={id} className="control-plane-nav-children" hidden={!expanded}>
              {children.map(item => <li key={item.path}>{link(item, 'child')}</li>)}
              {!children.length && <li><span className="control-plane-nav-empty">No shortcuts available for your current role.</span></li>}
            </ul>
          </li>;
        })}
      </ul>
    </nav>
  </div>;
}
